import { render, staticRenderFns } from "./ClientHistory.vue?vue&type=template&id=dc2397d0&scoped=true&"
import script from "./ClientHistory.vue?vue&type=script&lang=js&"
export * from "./ClientHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2397d0",
  null
  
)

export default component.exports